export const AUTOMATIONS_CUSTOM_REQUEST_MAX_LENGTH = 2000;

/** The server resolves the comedian's name and the requester's email; the client sends neither. */
export interface AutomationsCustomRequestInput {
  artistId: string;
  message: string;
}

export type AutomationsCustomRequestSurface =
  | "checkout"
  | "change_plan"
  | "plan_usage";
